export default {"src":"/_next/static/media/weETH.b1e78bce.svg","height":256,"width":256};